import React, {Component} from 'react';
import TextField from 'material-ui/TextField';
import {orange500} from 'material-ui/styles/colors';
import FlatButton from 'material-ui/FlatButton';
import Checkbox from 'material-ui/Checkbox';
import AutoComplete from 'material-ui/AutoComplete';

import LoadingIndicator from './shared/LoadingIndicator';

import CompanyList from './shared/CompanyList';
import CompanyService from '../service/companies';
import BaseService from '../service/baseservice';
import AdminHeader from './AdminHeader';

export default class UnpublishedPage extends Component {

  state = {
    foundCompanies: [],
    searching: true,
    selectedCompanies: [],
    fetchLimit: 50,
    total: undefined,
    isSearchingMore: false,
    unassignedOnly: false,
    selectedIndustry: undefined
  };

  componentDidMount() {
    BaseService.addListener(this.dataUpdated.bind(this));
  }

  dataUpdated() {
    this.fetchCompanies()
  }

  fetchCompanies() {
    const { fetchLimit, unassignedOnly, selectedIndustry } = this.state

    CompanyService.findUnpublishedCompanies(fetchLimit, unassignedOnly, selectedIndustry).then(result => {
      this.setState({ foundCompanies: result.companies, total: result.count, searching: false, isSearchingMore: false })
    })
  }

  fetchMoreCompanies() {
    this.setState({ fetchLimit: this.state.fetchLimit + 50, isSearchingMore: true }, () => this.fetchCompanies())
  }

  onUnassignedOnlyToggled() {
    this.setState({ 
      fetchLimit: 50, 
      searching: true, 
      unassignedOnly: !this.state.unassignedOnly
    }, () => { this.fetchCompanies() })
  }

  onIndustryChanged = (chosenRequest, index) => {
    this.setState({
      selectedIndustry: BaseService.fetchedData.industries[index],
      fetchLimit: 50,
      searching: true
    }, () => { this.fetchCompanies() })
  }

  onSelectedCompanies(selectedCompanies) {
    setTimeout(function() {
      this.setState({ selectedCompanies });
    }.bind(this), 0);
  }

  onRefreshList() {
    this.fetchCompanies()
  }

  render() {
    var content = <LoadingIndicator />;
    return (
      <div>
        <AdminHeader selected="unpublished" />
        {this.renderHeader()}
        {this.renderContent()}
        {this.renderLoadMoreButton()}
      </div>
    );
  }

  renderHeader() {
    return  <div style={{padding: '24px', paddingLeft: '30px' }}>
      <AutoComplete
        style={{marginLeft: '15px'}}
        dataSource={BaseService.fetchedData.industries}
        dataSourceConfig={{text: 'name', value: '_id'}}
        filter={AutoComplete.caseInsensitiveFilter}
        floatingLabelText="Valitse toimiala"
        listStyle={{width:'100%'}}
        hintText="Kaikki toimialat"
        maxSearchResults={10}
        onNewRequest={this.onIndustryChanged}
      />
    <div style={{display: 'inline-block', marginLeft: '25px', width: '300px'}}>
      <Checkbox disabled={this.state.searching} 
        label="Näytä vain ilman myyjää olevat"
        checked={this.state.unassignedOnly}
        disabled={this.state.searching || this.state.isSearchingMore}
        onCheck={() => this.onUnassignedOnlyToggled()}/>
    </div>
  </div>
  }

  renderContent() {
    if (!this.state.searching) {
      return <div>
        <CompanyList multiSelectable={true}
          companies={this.state.foundCompanies}
          onSelectedCompanies={(selectedCompanies) => this.onSelectedCompanies(selectedCompanies)}
          selectedCompanies={this.state.selectedCompanies}
          refreshList={() => this.onRefreshList()}
          total={this.state.total} />
        </div>
    } else {
      return <LoadingIndicator/>
    }
  }

  renderLoadMoreButton() {
    if (this.state.isSearchingMore) {
      return <LoadingIndicator/>
    } else if (this.state.total && this.state.total > this.state.fetchLimit && !this.state.searching) {
      let more = Math.min(this.state.total - this.state.fetchLimit, 50)
      return <FlatButton 
        style={{width:'100%', marginTop:'20px', marginBottom: '100px'}} 
        label={"Lataa " + more + " lisää"} 
        onClick={() => this.fetchMoreCompanies()}></FlatButton>
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/UnpublishedPage.js